import useAuth from './useAuth';

// Compute-token UI is on for any signed-in non-anonymous user.
// Server-side ledger + CloudSpendGuard are unchanged.
export default function useComputeTokensVisible() {
  const { user, loading } = useAuth();
  if (loading) return false; // fail closed while auth resolves
  return !!(user && !user.isAnonymous);
}
